import axios from "axios";
import { API_URL } from "./config";

export default class OperationModeService {
    static getToken() {
        return sessionStorage.getItem("access_token")
    }

    static async getOperationModes() {
        const token = this.getToken()
        const response = await axios.get(`${API_URL}/OperationMode/GetOperationModes`, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
            withCredentials: true
        })
        return response;
    }

    static async changeOperationMode(id) {
        const token = this.getToken()
        const response = await axios.get(`${API_URL}/OperationMode/ChangeOperationMode`, {
            params: {
                operationModeId: id
            },
            headers: {
                "Authorization": `Bearer ${token}`
            },
            withCredentials: true
        })
        return response;
    }

    static async updateOperationMode(mode) {
        const token = this.getToken()
        const response = await axios.post(`${API_URL}/OperationMode/UpdateOperationMode`, mode, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
            withCredentials: true
        })
        return response;
    }
}